import React, { FC, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useStore } from '@store';

interface IContent {
  summary: string;
  smallIconUrl: string;
  title: string;
  contentUrl: string;
}

interface IHeadPageProps {
  title: string;
  description?: string;
  contentItem?: IContent;
}

const HeadPage: FC<IHeadPageProps> = ({ title, description, contentItem }): React.ReactElement => {
  const { setDashboardTitle } = useStore();
  useEffect(() => {
    setDashboardTitle(title);
  }, [title]);

  return (
    <Helmet>
      <title>{`Tadatoon | ${title}`}</title>
      {description && !contentItem && <meta name='description' content={description} />}
      {contentItem && [
        <meta key='description' name='description' content={contentItem.summary} />,
        <meta key='og:description' property='og:description' content={contentItem.summary} />,
        <meta key='og:image' property='og:image' content={contentItem.smallIconUrl} />,
        <meta key='og:title' property='og:title' content={contentItem.title} />,
        <meta key='og:type' property='og:type' content='website' />,
      ]}
    </Helmet>
  );
};

export default HeadPage;
